import { Injectable } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { LocalstorageService } from "./localstorage.service";

@Injectable({
  providedIn: "root",
})
export class VolunteerGuardService {
  constructor(
    private router: Router,
    private localstorageService: LocalstorageService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let url: string = state.url;
    return this.verifyEmployee(url);
  }

  verifyEmployee(url: string) {
    if (this.localstorageService.isAuthenticated()) {
      return true;
    }

    this.localstorageService.requestedUrl = "/volunteer";

    this.router.navigateByUrl("/verify/volunteer");

    return false;
  }
}
